export const VERSION = '2.0.12'

export const COMPANY_NAME = 'Local Chapter'

export const isDev = process.env.REACT_APP_ENV === 'dev'

export const SHOWN_TAGS = [
    'Muslim_owned',
    'Halal Certified',
    'Vegetarian',
    'Vegan',
    'Dairy',
    'Beef',
    'Seafood',
    'Pork/Lard',
    'Chicken',
    'Duck',
    'Lamb',
    'Fish',
    'Veg',
    'Pork',
]

export const BANNER_ITEMS = [
    {
        src: 'https://images.pexels.com/photos/17308455/pexels-photo-17308455/free-photo-of-a-sushi-roll-with-a-slice-of-lemon-and-a-slice-of-avocado.jpeg?auto=compress&cs=tinysrgb&w=1200',
        alt: 'Sushi Roll',
    },
    {
        src: 'https://images.pexels.com/photos/17308547/pexels-photo-17308547/free-photo-of-a-bowl-of-rice-with-meat-and-vegetables.jpeg?auto=compress&cs=tinysrgb&w=1200',
        alt: 'Rice Bowl',
    },
    {
        src: 'https://images.pexels.com/photos/17308560/pexels-photo-17308560/free-photo-of-a-bowl-of-food-with-meat-and-vegetables.jpeg?auto=compress&cs=tinysrgb&w=1200',
        alt: 'Delicious Food',
    },
]

export const CATEGORIES = ['Main', 'Side', 'Vegetable', 'Staple', 'Dessert', 'Drink']

export const BLOCKS_CART_PAGE = ['order', 'payment', 'payment-complete', 'checkout-assistant', 'force-rating']

export const BLOCKS_NAV_SPACER_PAGE = ['payment']

export const DINING_METHOD = {
    DineIn: 'DineIn',
    Takeaway: 'Takeaway',
    AdvanceTakeaway: 'AdvanceTakeaway',
}

export const DINING_METHOD_OPTIONS = [
    { value: DINING_METHOD.DineIn, label: 'Dine In' },
    { value: DINING_METHOD.Takeaway, label: 'Takeaway' },
    { value: DINING_METHOD.AdvanceTakeaway, label: 'Advance Takeaway' },
]

export const PRODUCT_SELECTION_TYPE = {
    NORMAL: 'NORMAL', // for normal selection type (>0)
    SINGLE: 'SINGLE', // Optional (maximum 1 selection) (-1)
    MULTIPLE: 'MULTIPLE', // Optional (no maximum selection) (-2)
    MINIMUM: 'MINIMUM', // Minimum 2 or more selections required (-3)
    TAKEAWAY: 'TAKEAWAY', // Takeaway special options (required when dine-in is false) (-4)
}

export const SINGLE_SELECTION = [PRODUCT_SELECTION_TYPE.SINGLE, PRODUCT_SELECTION_TYPE.TAKEAWAY]

export const INVENTORY_STATUS = {
    ACTIVE: 'ACTIVE',
    CHECK_AVAILABLE: 'CHECK_AVAILABLE',
    SOLD_OUT: 'SOLD_OUT',
}

export const ORDER_STATUS = {
    UNPAID: 'Unpaid',
    PAID: 'Paid',
    COMPLETED: 'Completed',
}

// Backend order status enum (for API)
export const ORDER_STATUS_BACKEND = {
    UNPAID: 'UNPAID',
    PAID: 'PAID',
    COMPLETED: 'COMPLETED',
}

// Order history filter category enum
export const ORDER_HISTORY_FILTER_CATEGORY = {
    ALL: 'All',
    COMPLETED: 'Completed',
    PAID: 'Paid',
    UNPAID: 'Unpaid',
}

// Order history filter category options
export const ORDER_HISTORY_FILTER_CATEGORY_OPTIONS = [
    { value: ORDER_HISTORY_FILTER_CATEGORY.ALL, label: 'All' },
    { value: ORDER_HISTORY_FILTER_CATEGORY.COMPLETED, label: 'Completed' },
    { value: ORDER_HISTORY_FILTER_CATEGORY.PAID, label: 'Paid' },
    { value: ORDER_HISTORY_FILTER_CATEGORY.UNPAID, label: 'Unpaid' },
]

// Mapping from filter category to backend status
export const ORDER_HISTORY_FILTER_TO_BACKEND_STATUS = {
    [ORDER_HISTORY_FILTER_CATEGORY.ALL]: [],
    [ORDER_HISTORY_FILTER_CATEGORY.COMPLETED]: [ORDER_STATUS_BACKEND.COMPLETED],
    [ORDER_HISTORY_FILTER_CATEGORY.PAID]: [ORDER_STATUS_BACKEND.PAID],
    [ORDER_HISTORY_FILTER_CATEGORY.UNPAID]: [ORDER_STATUS_BACKEND.UNPAID],
}

export const GST_STALL_LIST = ['Tian Tian']

export const PAYMENT_METHOD = {
    Cash: 'CASH',
    PayNow: 'PAYNOW',
    PayWave: 'PAYWAVE',
}

export const PAYMENT_METHOD_OPTIONS = [
    { value: PAYMENT_METHOD.Cash, label: 'Cash' },
    { value: PAYMENT_METHOD.PayNow, label: 'PayNow' },
    // don't allow PayWave for customers to select
    // { value: PAYMENT_METHOD.PayWave, label: 'PayWave' },
]

export const PUB_SUB_EVENT = {
    // NEW_ORDER: 'new_order',
    // VOID_ORDER: 'void_order',
    COMPLETED_ORDER: 'completed_order',
    ORDER_PAYMENT_STATUS_UPDATE: 'order_payment_status_update',
    INVENTORY_STATUS_UPDATE: 'inventory_status_update',
    COMPLETED_DISH: 'completed_dish',
}

export const PUBSUB_GROUP_EVENT = {
    PING_GROUP: 'ping_group',
    PAYMENT_LATER: 'payment_later',
    PAYMENT_REQUEST: 'payment_request',
    PAYMENT_PAYNOW_SUCCESS: 'payment_paynow_success',
    PAYMENT_PAYWAVE_SUCCESS: 'payment_paywave_success',
    PAYMENT_SUCCESS: 'payment_success',
    PAYMENT_FAILED: 'payment_failed',
    PAYMENT_CANCEL: 'payment_cancel',
    CART_SNAPSHOT: 'cart_snapshot',
}

export const CONNECTION_STATUS = {
    DISCONNECTED: 'disconnected',
    CONNECTING: 'connecting',
    CONNECTED: 'connected',
    ERROR: 'error',
}

export const OTP_EXPIRY_TIME = 2 * 60 // 2 minutes (same as backend)

export const PTS_TO_DOLLAR = 100 // 100 pts = $1.00

export const CASH_UNIT_CENTS = 10 // 10 cents = minimum cash unit

export const MEMBER_ROLE = {
    Member: 1,
    StallStaff: 2,
    HQStaff: 3,
    Management: 4,
    Admin: 5,
}

export const MEMBER_ROLE_CODE = {
    Member: 'Member',
    StallStaff: 'StallStaff',
    HQStaff: 'HQStaff',
    Management: 'Management',
    Admin: 'Admin',
}

export const PROMO_TYPES = {
    MORNING_B3G1: 'MORNING_B3G1',
    KOPI_TEH_1OFF_MIN5: 'KOPI_TEH_1OFF_MIN5',
}
